import SwiperSlider from "../components/abstract/SwiperSlider";
import $ from 'jquery';

export default class SliderTitolo extends SwiperSlider {
  constructor(element, context) {
    super(element, context);

    this.options = {
      centeredSlides: true,
      speed: parseInt(this.getData('speed', 15000)),
      allowTouchMove: false,
      slidesPerView: 'auto',
      loop: true,
      autoplay: {
        delay: 1,
      },
      spaceBetween: 50,
    };

    $(() => {
      this.init();
    });
  }
}
